<lib-cardy-ai [RBACORG]="RBACORG" [COMMONSERVICE]="cardyaiEvent$"></lib-cardy-ai>